import Marquee from "react-fast-marquee";

const ITEMS = [
  "BRISBANE",
  "NORTH BRISBANE",
  "SUNSHINE COAST",
  "COMMERCIAL",
  "INDUSTRIAL",
];

export default function TextMarquee() {
  return (
    <div
      data-testid="marquee-ribbon"
      className="border-y border-border bg-obsidian py-8 overflow-hidden"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display uppercase tracking-tight text-6xl lg:text-8xl text-stroke px-8">
              {item}
            </span>
            <span className="w-3 h-3 bg-acid rotate-45 mx-2" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
